export default __webpack_public_path__ + "static/media/cross.f63027b4.svg";